module.exports = __webpack_public_path__ + "img/12223_23.6d3819f8.png";